import * as React from 'react';

import { observer } from 'mobx-react';
import WeekStartDay from './WeekStartDay';
import saveWeekStartDayQuickSetting from '../orchestration/saveWeekStartDayQuickSetting';

const styles = require('./AppearanceQuick.scss');

/**
 * Wrapper component which renders the individual settings inside calendar appearance option
 */
export default observer(function AppearanceQuick() {
    return (
        <div className={styles.appearanceWrapper}>
            <WeekStartDay
                saveWeekStartDayQuickSetting={saveWeekStartDayQuickSetting}
                isQuick={true}
            />
        </div>
    );
});
